import React from "react";
import { Link } from "react-router-dom";
import { prductData } from "../Data";

const ProductGrid = () => (
  <section className="py-8 md:py-12 px-5 lg:px-12 max-w-7xl mx-auto">
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {prductData.map((post, index) => (
        <Link
          key={index}
          to={`/product/${post.id}`}
          className="group flex flex-col bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-sm border border-slate-100 hover:shadow-md hover:border-blue-200 transition-all duration-300"
          data-aos="fade-up"
          data-aos-delay={index * 50}
        >
          {/* image */}
          <div className="relative overflow-hidden h-36 md:h-56 bg-slate-50 flex items-center justify-center p-4">
            <img
              src={post.image}
              className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
              alt={post.title}
            />
          </div>

          {/* content */}
          <div className="p-3 md:p-6 flex flex-col flex-grow">
            <h3 className="text-sm md:text-xl font-bold uppercase text-slate-900 mb-1 md:mb-3 tracking-tight group-hover:text-blue-600 transition-colors leading-snug line-clamp-2">
              {post.title}
            </h3>
            <p className="text-slate-500 text-[10px] md:text-xs leading-relaxed mb-3 md:mb-6 line-clamp-2 md:line-clamp-3 hidden sm:block">
              {post.description.split('\n')[0]}
            </p>

            <div className="mt-auto pt-2 md:pt-4 border-t border-slate-50">
              <span className="inline-flex items-center text-[10px] md:text-[10px] font-bold uppercase tracking-widest text-blue-600 group-hover:text-blue-800 transition-all">
                View Details
                <svg
                  className="w-2.5 h-2.5 ml-1 transition-transform group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

const Product = ({ openDemo }) => (
  <div className="bg-slate-50 min-h-screen">
    {/* banner */}
    <div data-theme="dark" className="h-48 md:h-64 relative flex items-center justify-center text-white overflow-hidden bg-gradient-to-b from-[#060b13] via-[#0b172a] to-[#050a12] rounded-b-[2.5rem] border-b border-blue-900/30 pt-[82px]">
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.06) 1px,transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />
      {/* gradient blobs */}
      <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-blue-600/25 blur-[80px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-indigo-600/15 blur-[80px] pointer-events-none" />

      <div className="relative z-10 text-center px-4" data-aos="zoom-out">
        <h1 className="text-3xl md:text-5xl font-teko uppercase tracking-wider">
          Products
        </h1>
      </div>
    </div>

    {/* intro */}
    <div className="max-w-4xl mx-auto text-center px-5 pt-8 md:pt-12 pb-2 md:pb-4">
      <div data-aos="fade-up">
        <div className="mb-3">
          <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
            Our Portfolio
          </span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-teko uppercase text-slate-900 tracking-wide mb-3">
          Specialized Software Solutions
        </h2>
        <p className="text-slate-500 text-sm max-w-2xl mx-auto">
          We build robust and intuitive software products designed to simplify complex workflows
          and drive operational excellence.
        </p>
      </div>
    </div>

    <ProductGrid />
  </div>
);

export default Product;
